import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Combobox } from '@flywire/react-headlessui';
import { cx } from '../../utils';
export const useErrorClasses = ({ className }) => {
    return cx('text-xs font-medium text-red-600', className);
};
const ComboboxErrorComponent = forwardRef(({ className, ...rest }, ref) => {
    const classes = useErrorClasses({ className });
    return _jsx(Combobox.Error, { className: classes, ref: ref, ...rest });
});
ComboboxErrorComponent.displayName = 'Error';
const ComboboxError = ComboboxErrorComponent;
export { ComboboxError };
//# sourceMappingURL=Error.js.map